import React from "react";
import { Form, Input, Row, Col } from "antd";
import { validateName, phoneValidator, emailValidator, faxValidator } from "../../../../utils/validator";

const { TextArea } = Input;

const ReferralSection = () => {
  return (
    <div className="p-5">
      <Row gutter={[16, 16]}>
        <Col span={12} sm={24} md={24} lg={12}>
          <Row gutter={[16, 16]}>
            <Col span={12} sm={24} md={12} lg={12}>
              <Form.Item
                name="referral_Provider_fullName"
                label="Doctor Full Name"
                rules={[{ validator: validateName }]}
              >
                <Input placeholder="Doctor Full Name" maxLength={30} />
              </Form.Item>
            </Col>
            <Col span={12} sm={24} md={12} lg={12}>
              <Form.Item
                name="referral_Provider_speciality"
                label="Speciality"
              >
                <Input
                  placeholder="Referral Speciality"
                  maxLength={30}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12} sm={24} md={12} lg={12}>
              <Form.Item
                name="referral_Provider_phone"
                label="Phone"
                rules={[{ validator: phoneValidator }]}
              >
                <Input
                  placeholder="Referral Phone number"
                  maxLength={20}
                />
              </Form.Item>
            </Col>
            <Col span={12} sm={24} md={12} lg={12}>
              <Form.Item
                name="referral_Provider_email"
                label="Email"
                rules={[{ validator: emailValidator }]}
              >
                <Input placeholder="Referral Email" maxLength={30} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12} sm={24} md={12} lg={12}>
              <Form.Item
                name="referral_Provider_fax"
                label="Fax"
                rules={[{ validator: faxValidator }]}
              >
                <Input placeholder="Referral Fax" />
              </Form.Item>
            </Col>
          </Row>
        </Col>

        <Col span={12} sm={24} md={24} lg={12}>
          <Row gutter={[16, 16]}>
            <Col span={12} sm={24} md={12} lg={12}>
              <Form.Item name="organization_name" label="Organization">
                <Input placeholder="Organization Name" maxLength={30} />
              </Form.Item>
            </Col>
            <Col span={12} sm={24} md={12} lg={12}>
              <Form.Item name="group" label="Group">
                <Input placeholder="Group Name" maxLength={30} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col span={12} sm={24} md={12} lg={12}>
              <Form.Item
                name="wdyhau"
                label="Where did you hear About Us? (Referral Source)"
              >
                <Input
                  placeholder="Maps, Friends, Facebook etc."
                  maxLength={30}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              <Form.Item name="referal_notes" label="Notes">
                <TextArea showCount maxLength={300} />
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default React.memo(ReferralSection);
